
export default {
  FETCH_SEND_MAIL_DOWNLOAD: 'FETCH_SEND_MAIL_DOWNLOAD'
}
